import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { googleAnalyticsHeadScripts } from './app/script-tag-ga';

if (environment.production) {
  enableProdMode();
  googleAnalyticsHeadScripts();
}

platformBrowserDynamic().bootstrapModule(AppModule);
